(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MQ = window.matchMedia('(min-width: 990px)');

    function init(root) {
      if (!root || root.__cbMega) return;
      root.__cbMega = true;

      var items = root.querySelectorAll('.cb-mega__item.has-panel');
      var toggle = root.querySelector('.cb-mega__toggle');
      var hover = root.getAttribute('data-hover') === 'true';
      var timer;

      function setOpen(li, open) {
        li.classList.toggle('is-open', open);
        var b = li.querySelector('.cb-mega__expand');
        if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function closeAll(except) {
        items.forEach(function (li) { if (li !== except) setOpen(li, false); });
      }

      items.forEach(function (li) {
        var b = li.querySelector('.cb-mega__expand');
        b.addEventListener('click', function () {
          var willOpen = !li.classList.contains('is-open');
          closeAll(li);
          setOpen(li, willOpen);
        });
        li.addEventListener('mouseenter', function () {
          if (!hover || !MQ.matches) return;
          clearTimeout(timer);
          closeAll(li);
          setOpen(li, true);
        });
        li.addEventListener('mouseleave', function () {
          if (!hover || !MQ.matches) return;
          timer = setTimeout(function () { setOpen(li, false); }, 150);
        });
      });

      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = !root.classList.contains('is-menu-open');
          root.classList.toggle('is-menu-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openLi = root.querySelector('.cb-mega__item.is-open');
        if (openLi) {
          setOpen(openLi, false);
          var b = openLi.querySelector('.cb-mega__expand');
          if (b) b.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closeAll();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-cb-mega]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
